import { render, staticRenderFns } from "./ReceptionnaireForm.vue?vue&type=template&id=764564c6&"
import script from "./ReceptionnaireForm.vue?vue&type=script&lang=js&"
export * from "./ReceptionnaireForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports